export class ShipmentNotificationType {
    public display: string;
    public value: string;

    constructor(value: string, display: string) {
        this.value = value;
        this.display = display;
    }
}

export const ShipmentNotificationTypeMetadata = {
    productionSummary: new ShipmentNotificationType('ps', 'Production Summary'),
    preliminaryDelivery: new ShipmentNotificationType('pd', 'Preliminary Delivery'),
    finalDelivery: new ShipmentNotificationType('fd', 'Final Delivery'),
};
